<template>
  <div class="page-content ride-credits">
    <h5 class="pb-10">
      You can use this page to view and add GoGo Credits to your customer.
    </h5>

    <div class="row">
      <div class="col-sm-12">
        <add-ride-credits />

        <partner-ride-credits-usages />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const PartnerRideCreditsUsages = defineAsyncComponent(() => import('./PartnerRideCredits/PartnerRideCreditsUsages.vue') as any);
const AddRideCredits = defineAsyncComponent(() => import('@/components/Main/Shared/AddRideCredits.vue') as any);
</script>
